import React, { Fragment, useContext } from "react";
import Modal from "../modal/modal";
import LinkInputs from "./input/LinkInputs";
import MainInputs from "./input/MainInputs";
import INPUT_DATA from "../../data/pageInputs";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import LoadingContext from "../../context/LoadingContext";

function Form(props) {
  const loading = useContext(LoadingContext);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const editMode = searchParams.get("editmode");
  const pageName = location.pathname.slice(1);
  const itemdId = searchParams.get("itemid");
  const type = searchParams.get("type");
  const data = `${
    pageName
      ? pageName.split("-")[0].toUpperCase() + "_" + type.toUpperCase()
      : "ABOUT"
  }_DATA`;
  const FORM_DATA = INPUT_DATA[data];
  const link = INPUT_DATA.link;

  const [state, setState] = useState({
    formData: FORM_DATA,
  });

  const currentItem = props.items.find((i) => i._id === itemdId);

  useEffect(() => {
    if (editMode && currentItem) {
      setState((prevState) => {
        let count;
        const itemData = { ...FORM_DATA.itemData };

        Object.entries(currentItem).forEach(([key, value]) => {
          if (key === "links") {
            count = currentItem.links.length;

            value.forEach((l) => {
              itemData.links = [
                ...itemData.links,
                {
                  name: {
                    ...link.name,
                    value: l.name,
                    isValid: true,
                    touched: true,
                  },
                  url: {
                    ...link.url,
                    value: l.url,
                    isValid: true,
                    touched: true,
                  },
                },
              ];
            });
          } else if (key !== "__v" || key !== "_id") {
            itemData[key] = {
              ...prevState.formData.itemData[key],
              value: value,
              isValid: true,
              touched: true,
            };
          }
        });

        return {
          ...prevState,
          formData: {
            ...prevState.formData,
            itemData: itemData,
            linksCount: count,
          },
        };
      });
    }
  }, [editMode, currentItem]);

  const itemInputChangeHandler = (input, value, files) => {
    setState((prevState) => {
      let isValid = true;
      if (!files) {
        for (const validator of prevState.formData.itemData[input].validators) {
          isValid = isValid && validator(value);
        }
      }
      const updatedData = {
        ...prevState.formData.itemData,
        [input]: {
          ...prevState.formData.itemData[input],
          value: files ? files[0] : value,
          isValid: isValid,
          touched: true,
        },
      };
      return {
        ...prevState,
        formData: {
          ...prevState.formData,
          itemData: updatedData,
        },
      };
    });
  };

  const itemInputBlurHandler = (input) => {
    setState((prevState) => {
      const updatedData = {
        ...prevState.formData.itemData,
        [input]: {
          ...prevState.formData.itemData[input],
          touched: true,
        },
      };
      return {
        ...prevState,
        formData: {
          ...prevState.formData,
          itemData: updatedData,
        },
      };
    });
  };

  const linkInputChangeHandler = (input, value, files, index) => {
    setState((prevState) => {
      const current = prevState.formData.itemData.links[index][input];
      let isValid = true;
      for (const validator of current.validators) {
        isValid = isValid && validator(value);
      }
      const updatedLinks = prevState.formData.itemData.links.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            [input]: {
              ...item[input],
              value: value,
              isValid: isValid,
              touched: true,
            },
          };
        }
        return item;
      });
      return {
        ...prevState,
        formData: {
          ...prevState.formData,
          itemData: {
            ...prevState.formData.itemData,
            links: updatedLinks,
          },
        },
      };
    });
  };

  const linkInputBlurHandler = (input, value, files, index) => {
    setState((prevState) => {
      const updatedLinks = prevState.formData.itemData.links.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            [input]: {
              ...item[input],
              touched: true,
            },
          };
        }
        return item;
      });
      return {
        ...prevState,
        formData: {
          ...prevState.formData,
          itemData: {
            ...prevState.formData.itemData,
            links: updatedLinks,
          },
        },
      };
    });
  };

  const cancelPostChangeHandler = () => {
    setState({ formData: FORM_DATA });
    props.onCancelEdit();
  };

  const acceptPostChangeHandler = (e) => {
    e.preventDefault();
    const item = {};

    Object.entries(state.formData.itemData).forEach(([key, innerObj]) => {
      if (key === "image" && innerObj.value === "") {
      } else if (key === "links") {
        item.links = [];
        innerObj.forEach((l) => {
          item.links = [
            ...item.links,
            { name: l.name.value, url: l.url.value },
          ];
        });
      } else {
        item[key] = innerObj.value;
      }
    });

    props.onFinishEdit(item);

    setState({ formData: FORM_DATA });
  };

  const newInputHandler = (e) => {
    e.preventDefault();

    setState((prevState) => {
      return {
        ...prevState,
        formData: {
          ...prevState.formData,
          itemData: {
            ...prevState.formData.itemData,
            links: state.formData.itemData.links.concat(link),
          },
          linksCount: prevState.formData.linksCount + 1,
        },
      };
    });
  };

  return (
    <Fragment>
      <Modal
        title={`${currentItem ? "Save" : "Add"} item`}
        onCloseModal={cancelPostChangeHandler}
        onAcceptModal={acceptPostChangeHandler}
        isError={false}
        button={currentItem ? "Save" : "Add"}
        isOpen={editMode}
      >
        {loading && (
          <div className="w-full text-center mt-2">
            <span className="loading loading-spinner loading-lg align-middle"></span>
          </div>
        )}
        {!loading && (
          <form className="w-full">
            <MainInputs
              mainData={state.formData.itemData}
              changeHandler={itemInputChangeHandler}
              blurHandler={itemInputBlurHandler}
            />
            {state.formData.itemData.links && (
              <>
                <LinkInputs
                  linksData={state.formData.itemData.links}
                  changeHandler={linkInputChangeHandler}
                  blurHandler={linkInputBlurHandler}
                />

                <div className="flex justify-center items-end flex-col mt-2 mb-2">
                  <span className="font-semibold text-base">
                    remaining links:{5 - state.formData.linksCount}
                  </span>
                  <button
                    onClick={newInputHandler}
                    disabled={state.formData.linksCount >= 5}
                    className="btn btn-wide"
                  >
                    Add link
                  </button>
                </div>
              </>
            )}
          </form>
        )}
      </Modal>
    </Fragment>
  );
}

export default Form;
